<template>
  <parent>
    <loading-page v-if="loading" />
    <div
      v-else
      class="general d-flex p-1 flex-column"
    >
      <div class="row mt-1">
        <input-field
          class="col-12 col-md-6"
          label="Organization ID"
          label-position="top"
        ><a
          v-clipboard:copy="organization.id"
          v-clipboard:success="copySuccess"
        >
          {{ organization.id }}
          <GjIcon
            name="Copy"
            size="20"
          /></a>
        </input-field>
        <input-field
          class="col-12 col-md-6"
          label="Organization name"
          label-position="top"
        >
          {{ organization.name }}
        </input-field>
      </div>
      <paper class="inner-paper mt-1">
        <template v-slot:title>
          <p class="mb-0 ">
            Organization Address
          </p>
        </template>
        <div class="row">
          <input-field
            class="col-12 col-md-6"
            label="Country"
            label-position="top"
          >
            <span class="text-lg">{{ organization.country || '-' }}</span>
          </input-field>
          <input-field
            class="col-12 col-md-6"
            label="City"
            label-position="top"
          >
            <span class="text-lg">{{ organization.city }}</span>
          </input-field>
        </div>
        <div class="row mt-1">
          <input-field
            class="col-12 col-md-6"
            label="Address Line1"
            label-position="top"
          >
            <span class="text-lg">{{ organization.addressLine1 || '-' }}</span>
          </input-field>
          <input-field
            class="col-12 col-md-6"
            label="Address Line 2"
            label-position="top"
          >
            <span class="text-lg">{{ organization.addressLine2 || '-' }}</span>
          </input-field>
        </div>
        <div class="row mt-1">
          <input-field
            class="col-12 col-md-6"
            label="Vat Number"
            label-position="top"
          >
            <span class="text-lg">{{ organization.vatNumber || '-' }}</span>
          </input-field>
        </div>
      </paper>
    </div>
  </parent>
</template>
<script>
import Paper from '@/components/paper/Paper.vue'

import redirectError from '@/services/redirectError'

export default {
  name: 'General',
  components: { Paper },
  data() {
    return {
      organizations: [],
      fields: [
        'id',
        'name',
        'addressLine1',
        'addressLine2',
        'country',
        'city',
        'vatNumber',
      ],
    }
  },
  computed: {
    organization() {
      return this.$store.state.organization.organization
    },
    loading() {
      return this.$store.state.organization.gettingOrganization
    },
  },
  created() {
    const { organizationId } = this.$store.state.app

    this.$store
      .dispatch('organization/getOrganization', organizationId)
      .then(() => {
        this.organizations.push(this.organization)
      })
      .catch(err => redirectError(err, this.$router, this.$route.path))
  },
}
</script>
<style lang="scss" scoped>
.inner-paper::v-deep {
  .card-header {
    padding: 16px 0;
  }
}
</style>
